import Flex from "components/Flex";
import PageLayout from "components/PageLayout";
import Text from "components/Text";

import { useClientTranslation } from "hooks/useClientTranslation";

export const DJCompleteClaimInCustomerPortalPage = () => {
  const { t } = useClientTranslation();

  return (
    <PageLayout contentSpacing="space-between" dataTestId="completeClaimOnCustomerPortal">
      <Flex px={24} py={24} gap={16} flex={1} mb={16} direction="column">
        <Text mb={8} as="h1" sizeVariant="xl" weight={600}>
          {t("digital_journey.complete_claim.title")}
        </Text>

        <Text whiteSpace="pre-line">
          {t("digital_journey.complete_claim.body")}
        </Text>
      </Flex>
    </PageLayout>
  );
};
